module.exports = __webpack_public_path__ + "static/media/mobile-background-input-forms.ba8c87e0.png";